<gp-hire-employee
  [employeeFileEnabled]="false"
  [profileMode]="profileMode">
</gp-hire-employee>
